import React, { createContext, useContext, useState } from "react";

import { ShipmentsTracking } from "../models/shipments/shipments.tracking";
import { ShipmentType } from "../util/enums";

interface ShipmentContextProps {
  shipmentTracking?: ShipmentsTracking;
  setShipmentTracking: (value: ShipmentsTracking) => void;
  handleUpdateShipmentTracking: (attribute: string, value: any) => void;
}

const ShipmentTrackingContext = createContext<ShipmentContextProps>({} as ShipmentContextProps);

interface ShipmentProviderProps {
  children: React.ReactChild;
}

const ShipmentTrackingProvider = ({ children }: ShipmentProviderProps) => {
  const [shipmentTracking, setShipmentTracking] = useState<ShipmentsTracking>({
    shipmentType: ShipmentType.SEA,
  } as ShipmentsTracking);

  const handleUpdateShipmentTracking = (attribute: string, value: any) => {
    if (attribute && attribute !== "all") {
      if (!["string", "number", "boolean", "object"].includes(typeof value))
        setShipmentTracking((state: any) => ({ ...state, [attribute]: [...value] }));
      else setShipmentTracking((state: any) => ({ ...state, [attribute]: value }));
    } else {
      setShipmentTracking({ ...value });
    }
  };

  return (
    <ShipmentTrackingContext.Provider
      value={{
        shipmentTracking,
        setShipmentTracking,
        handleUpdateShipmentTracking,
      }}
    >
      {children}
    </ShipmentTrackingContext.Provider>
  );
};

export { ShipmentTrackingProvider };

export const useShipmentTrackingContext = () => {
  const context = useContext(ShipmentTrackingContext);

  return context;
};
